import { generatePath } from 'react-router';
import { call } from 'redux-saga/effects';

import { PATH } from 'constants/RoutesConstants';
import { navigate } from 'modules/router/navigate';

import { CREATE_CAMPAIGN_SUCCESS, DUPLICATE_CAMPAIGN_SUCCESS } from '../actionTypes';
import { CREATION_MODAL_SOURCE, DUPLICATE_MODAL_SOURCE } from '../constants';

export const duplicateCampaignMatcher = ({ type, meta }) =>
  type === DUPLICATE_CAMPAIGN_SUCCESS && meta.source === DUPLICATE_MODAL_SOURCE;

export const createCampaignMatcher = ({ type, meta }) =>
  type === CREATE_CAMPAIGN_SUCCESS && meta.source === CREATION_MODAL_SOURCE;

export function* afterCreateCampaign({ payload: campaign }) {
  yield call(navigate, generatePath(PATH.CAMPAIGNS_DETAILS.path, { campaignId: campaign.id }));
}
